import { IOrderBy } from "../../../Global/Base/DataSources/Interfaces";

export interface IFrameColumnInfo {
    [key: string]: any;
    attrName: string;
    width?: number;
    order?: number;
    visible?: boolean;
    frozen?: boolean;
}

export interface IFrameProfileInfo {
    columns: { [attrName: string]: IFrameColumnInfo };
    order: IOrderBy[];
    attributesToGroup?: string[];
    filterId?: string;
    showSubRecords?: boolean;
}

export class IFrameProfileInfo {
    private static _properties: (keyof IFrameProfileInfo)[] = ["columns", "order"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

export enum FrameColumnInfoAttributes {
    width,
    order,
    visible,
    frozen,
}
